import { render, staticRenderFns } from "./comments-list.vue?vue&type=template&id=8334f40c"
import script from "./comments-list.vue?vue&type=script&lang=js"
export * from "./comments-list.vue?vue&type=script&lang=js"
import style0 from "./comments-list.vue?vue&type=style&index=0&id=8334f40c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports